import axios from 'axios'
import { notify } from 'react-notify-toast'

import { URIS, loadHeaders } from '../Uris'

import { profileConstants, attributesConstants, dashboardConstants, detectionsConstants, uiConstants } from '../constants'

export function loadProfile (payload) {
  return dispatch => {
    dispatch((loading()))
    axios({
      method: 'GET',
      url: URIS.profile,
      headers: loadHeaders(),
      data: payload
    }).then(res => {
      dispatch(loadSuccess(res.data))
    }).catch(error => {
      if (error.response !== undefined) { dispatch(loadFailure(error.response.statusText)) } else { dispatch(loadFailure(error.message)) }
      notify.show('Errore caricamento profilo', uiConstants.toast.error, 3000)
    })
  }
}

function loading () {
  return {
    type: profileConstants.LOAD_PROFILE
  }
}

function loadSuccess (payload) {
  return {
    type: profileConstants.LOAD_PROFILE_SUCCESS,
    payload
  }
}

function loadFailure (payload) {
  return {
    type: profileConstants.LOAD_PROFILE_FAILURE,
    payload
  }
}

export function changeActiveRole (payload) {
  return dispatch => {
    dispatch((changingRole()))
    axios({
      method: 'POST',
      url: URIS.profile,
      headers: loadHeaders(),
      data: payload
    }).then(res => {
      dispatch(loadSuccess(res.data))
      dispatch(resetPages())
      dispatch(resetSearch())
      dispatch(resetDetections())
      notify.show('Ruolo cambiato con successo', uiConstants.toast.success, 3000)
    }).catch(error => {
      if (error.response !== undefined) { dispatch(loadFailure(error.response.statusText)) } else { dispatch(loadFailure(error.message)) }
      notify.show('Errore cambio ruolo', uiConstants.toast.error, 3000)
    })
  }
}

function changingRole () {
  return {
    type: profileConstants.CHANGING_ROLE
  }
}

function resetPages () {
  return {
    type: attributesConstants.RESET_ATTRIBUTES
  }
}

function resetSearch () {
  return {
    type: dashboardConstants.RESET_SEARCH
  }
}

function resetDetections () {
  return {
    type: detectionsConstants.RESET_ALL
  }
}

export function changePassword (payload) {
  return dispatch => {
    dispatch(updatingPassword())
    axios({
      method: 'PUT',
      url: URIS.profile,
      headers: loadHeaders(),
      data: payload
    }).then(res => {
      dispatch(updatePasswordDone())
      notify.show('Password cambiata con successo', uiConstants.toast.success, 3000)
      // dispatch(loadSuccess(res.data))
      // dispatch(resetPages())
      // dispatch(resetSearch())
      // dispatch(resetDetections())
    }).catch(error => {
      if (error.response !== undefined) { dispatch(loadFailure(error.response.statusText)) } else { dispatch(loadFailure(error.message)) }
      notify.show('Errore cambio password', uiConstants.toast.error, 3000)
    })
  }
}

function updatingPassword () {
  return {
    type: profileConstants.UPDATING_PASSWORD
  }
}

function updatePasswordDone () {
  return {
    type: profileConstants.PASSWORD_UPDATED
  }
}
